import React from 'react';

import type { SpecSectionField } from 'Components/SpecSection/SpecSection.types';
import type { VehicleDetails } from 'Pages/vehicles/helpers/vehicle.schema';

import { HpiCheckFieldValue } from './HpiCheckFieldValue/HpiCheckFieldValue';
import { PreviousOwnersFieldValue } from './PreviousOwnersFieldValue/PreviousOwnersFieldValue';

export const VEHICLE_DETAILS_FIELDS: SpecSectionField<VehicleDetails>[] = [
	{
		fieldName: 'hpiHistoryCheck',
		isVisible: ({ value }) => value.isVehicleValid,
		label: () => 'HPI History Check',
		value: () => <HpiCheckFieldValue />,
	},
	{
		fieldName: 'registration',
		isVisible: () => true,
		label: () => 'Registration',
		value: ({ registration }) => registration,
	},
	{
		fieldName: 'vin',
		isVisible: () => true,
		label: () => 'VIN',
		value: ({ vin }) => vin,
	},
	{
		fieldName: 'firstRegistered',
		isVisible: () => true,
		label: () => 'First registered',
		value: ({ firstRegistered }) => firstRegistered,
	},
	{
		fieldName: 'keeperStartDate',
		isVisible: () => true,
		label: () => 'Keeper start date',
		value: ({ keeperStartDate }) => keeperStartDate,
	},
	{
		fieldName: 'previousOwners',
		isVisible: () => true,
		label: () => 'Previous owners',
		value: () => <PreviousOwnersFieldValue />,
	},
	{
		fieldName: 'numberOfKeys',
		isVisible: () => true,

		label: () => 'Number of keys',
		value: ({ numberOfKeys }) => numberOfKeys,
	},
	{
		fieldName: 'onFinance',
		isVisible: () => true,

		label: () => 'On finance',
		value: ({ onFinance }) => onFinance,
	},
	{
		fieldName: 'privatePlate',
		isVisible: () => true,
		label: () => 'Private plate',
		value: ({ privatePlate }) => privatePlate,
	},
	{
		fieldName: 'sellerKeepingPlate',
		isVisible: ({ value }) => Boolean(value.sellerKeepingPlate),
		label: () => 'Seller keeping plate',
		value: ({ sellerKeepingPlate }) => sellerKeepingPlate,
	},
	{
		fieldName: 'sellingVrm',
		isVisible: ({ value }) => value.sellerKeepingPlate === 'Yes' && Boolean(value.sellingVrm),
		label: () => 'Original VRM',
		value: ({ sellingVrm }) => sellingVrm,
	},
	{
		fieldName: 'isVatQualifying',
		isVisible: ({ value }) => Boolean(value.isVatQualifying),
		label: () => 'VAT qualifying',
		value: ({ isVatQualifying }) => isVatQualifying,
	},
];
